// ProductType Vuex

import state from './factoryStates.js'
import * as getters from './factoryGetters.js'
import * as mutations from './factoryMutations.js'
import * as actions from './factoryActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
